import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  RequestIndicatorTypes,
  GeneralCatalogItem,
} from 'data-layer-cr/dist/models';

export type CarCatalogState = {
  requestingBrandsStatus: RequestIndicatorTypes;
  requestingModelsStatus: RequestIndicatorTypes;
  brands: GeneralCatalogItem[];
  models: GeneralCatalogItem[];
};

const initialState: CarCatalogState = {
  requestingBrandsStatus: 'initial',
  requestingModelsStatus: 'initial',
  brands: [],
  models: [],
};

const carCatalogSlice = createSlice({
  name: 'carCatalog',
  initialState,
  reducers: {
    updateRequestingBrandStatus: (
      state,
      action: PayloadAction<RequestIndicatorTypes>,
    ): void => {
      state.requestingBrandsStatus = action.payload;
    },
    updateRequestingModelsStatus: (
      state,
      action: PayloadAction<RequestIndicatorTypes>,
    ): void => {
      state.requestingModelsStatus = action.payload;
    },

    updateBrands: (
      state,
      action: PayloadAction<GeneralCatalogItem[]>,
    ): void => {
      state.brands = action.payload;
    },

    updateModels: (
      state,
      action: PayloadAction<GeneralCatalogItem[]>,
    ): void => {
      state.models = action.payload;
    },
  },
});

export const {
  updateRequestingBrandStatus,
  updateRequestingModelsStatus,
  updateBrands,
  updateModels,
} = carCatalogSlice.actions;

export default carCatalogSlice.reducer;
